// UpgradePopup.js
import React, { useState, useEffect, useRef } from "react";
import "../styles/withoutloginpaypal.css";
import {
  fetchSubscriptionCheckUserExistsApi,
  fetchMasterlist,
  fetchSubscriptionRegisterUserApi,
  fetchWithoutLoginVerifySubscriptionApi,
} from "../api/api";
import SignupPopup from "../component/SignupPopup";

const UpgradePopup = ({ show, handleClose, selectedPlan, setToken, setSuccessMessagePrice }) => {
  const [showConfirmPassword, setConfirmPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    firstName: "",
    country: "",
  });
  const [fieldErrors, setFieldErrors] = useState({});
  const [countries, setCountries] = useState([]);
  const [showPopupSignup, setShowPopupSignup] = useState(false);
  const [error, setError] = useState("");
  const [customError, setCustomError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const paypalRef = useRef(null);
  const formRef = useRef(formData);
  useEffect(() => {
    formRef.current = formData;
  }, [formData]);


  const clientId = process.env.REACT_APP_PAYPAL_CLIENT_ID;

  const handleCloseSignup = () => {
    setShowPopupSignup(false);
    handleClose();
  };

  // Load country list
  useEffect(() => {
    const loadCountries = async () => {
      try {
        const response = await fetchMasterlist();
        if (response && Array.isArray(response.data.countrycodes)) {
          setCountries(response.data.countrycodes);
        } else {
          console.error("Invalid country response:", response);
        }
      } catch (err) {
        console.error("Error fetching countries:", err);
      }
    };

    loadCountries();
  }, []);

  // Validation logic
  const validate = async (data) => {
    const errors = {};
    const { email, password, confirmPassword, country } = data ? data : formData;
    if (!email.trim()) {
      errors.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(email)) {
      errors.email = "Invalid email format";
    } else {
      try {
        const res = await fetchSubscriptionCheckUserExistsApi(email);
        if (res && res.statuscode === 200) {
          setCustomError(res.message)
          errors.email = "This email already exists";
        }
      } catch (err) {
        console.error("Email check failed:", err);
      }
    }

    if (!password.trim()) errors.password = "Password is required";
    if (!confirmPassword.trim()) {
      errors.confirmPassword = "Confirm Password is required";
    } else if (password !== confirmPassword) {
      errors.confirmPassword = "Passwords do not match";
    }
    if (!country.trim()) errors.country = "Country is required";

    setFieldErrors(errors);

    const isValid = Object.keys(errors).length === 0;

    return  isValid
  };

   const handleSubmit = async (e) => {
    e.preventDefault();
    const isValid = await validate();
    if (!isValid) return;
  };

  // Form input handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFieldErrors((prev) => ({ ...prev, [name]: "" }));
  };


  // PayPal button rendering logic
  useEffect(() => {
    if (!show || !selectedPlan) return;

    const loadPayPalScript = () => {
      setLoading(true);

      if (document.getElementById("paypal-sdk")) { renderPaypalButtons(); return; }

      // // If script already exists in DOM
      // if (document.getElementById("paypal-sdk")) {
      //   const existingScript = document.getElementById("paypal-sdk");
      //   existingScript.addEventListener("load", renderPaypalButtons);
      //   return;
      // }

      // Load PayPal SDK dynamically
      const script = document.createElement("script");
      script.id = "paypal-sdk";
      script.src = `https://www.paypal.com/sdk/js?client-id=${clientId}&vault=true&intent=subscription`;
      script.async = true;
      script.onload = () => {
        console.log("PayPal SDK loaded.");
        renderPaypalButtons();
      };
      script.onerror = () => {
        console.error("Failed to load PayPal SDK script.");
        setError("Failed to load PayPal. Check clientId.");
        setLoading(false);
      };

      document.body.appendChild(script);
    };

    const renderPaypalButtons = () => {
      if (!paypalRef.current || !window.paypal) return;

      // Clear any previous button render
      paypalRef.current.innerHTML = "";

      window.paypal
        .Buttons({
          fundingSource: window.paypal.FUNDING.PAYPAL,
          style: {
            shape: "rect",
            color: "gold",
            layout: "vertical",
            label: "paypal",
            height: 45,
          },
          funding: { disallowed: [window.paypal.FUNDING.CARD] },
          createSubscription: async (data, actions) => {
            const latestData  = formRef.current;

            const isValid = await validate(latestData);

            if (!isValid) {
              
              // setError(isValid.customError || "Form validation failed. Please complete all required fields.");
              setShowPopupSignup(true);

              // setTimeout(() => {
              //   setShowPopupSignup(true);
              // }, 3000);
              throw new Error("Form validation failed. Please complete all required fields." || "Form validation failed.");
            }
            return actions.subscription.create({
              plan_id: selectedPlan.paypalplanid,
              custom_id: `${latestData.email}`,
            });
          },
          onApprove: async (data) => {
            const latestData  = formRef.current;
            // try {
            //   const res = await fetchSubscriptionRegisterUserApi({
            //     username: latestData.email,
            //     password: latestData.password,
            //     firstname: latestData.firstName,
            //     country: latestData.country,
            //     subscriptionid: selectedPlan.subscriptionid,
            //     productid: selectedPlan.productid,
            //     isDirectProUser: true
            //   });

            //   if (res.statuscode === 200) {
            //     setSuccessMessage("Registration successful!");
            //     setError("");
            //   } else {
            //     setError(res.message || "Registration failed.");
            //   }
            // } catch {
            //   setError("An error occurred while registering your account.");
            // }

            try {
              const subscriptionId = data.subscriptionID;
              const result = await fetchWithoutLoginVerifySubscriptionApi(
                latestData.email,
                latestData.firstName,
                latestData.password,
                latestData.country,
                subscriptionId,
                selectedPlan.productid,
                selectedPlan.subscriptionid,
              );

              if (result.status === "ACTIVE") {
                setPaymentSuccess(true);
                setError("");
                handleClose();
                setSuccessMessagePrice(true);
                // setTimeout(() => {
              //   setShowPopupSignup(true);
              // }, 3000);
              } else {
                setError(`${result.reason}`);
                // setTimeout(() => {
              //   setShowPopupSignup(true);
              // }, 3000);
              }
            } catch (err) {
              console.error("Verification failed:", err);
              setError("Failed to verify subscription.");
            }
          },
          onError: (err) => {
            setError(err ? err.message : "Payment failed. Try again.");
          },
        })
        .render(paypalRef.current)
        .then(() => setLoading(false));
    };

    loadPayPalScript();

    // Cleanup PayPal buttons on close
    return () => {
      if (paypalRef.current) {
        paypalRef.current.innerHTML = "";
      }
    };
  }, [show, selectedPlan, clientId]);


  if (!show) return null;

  return (
    <>
      {!showPopupSignup && (
        <div className="upgradelogin-popup-overlay">
          <div className="upgradelogin-popup-container">
            <div className="upgradelogin-header">
              <button className="upgradelogin-popup-close" onClick={handleClose}>
                ×
              </button>
            </div>

            <h2 className="upgradelogin-popup-title">
              Upgrade to Pro
            </h2>
            {error && <p className="error-text-paypal">{error}</p>}
            {successMessage && <p className="success-text">{successMessage}</p>}

            <form className="upgradelogin-popup-form" onSubmit={handleSubmit}>
              <label>Email address *</label>
              <input
                type="email"
                name="email"
                placeholder="you@example.com"
                value={formData.email}
                onChange={handleChange}
                className={fieldErrors.email ? "input-error" : ""}
                autoComplete="off"
              />
              {fieldErrors.email && (
                <p className="field-error-upgradelogin">{fieldErrors.email}</p>
              )}

              <label>Password *</label>
              <div className="password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Enter password"
                  value={formData.password}
                  onChange={handleChange}
                  className={fieldErrors.password ? "input-error" : ""}
                  autoComplete="new-password"
                />
                <span
                  className="password-toggle"
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  {showPassword ? "Hide" : "Show"}
                </span>
              </div>
              {fieldErrors.password && (
                <p className="field-error-upgradelogin">{fieldErrors.password}</p>
              )}

              <label>Confirm Password *</label>
              <div className="password-wrapper">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  placeholder="Re-enter password"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  className={fieldErrors.confirmPassword ? "input-error" : ""}
                  autoComplete="new-password"
                />
                <span
                  className="password-toggle"
                  onClick={() => setConfirmPassword((prev) => !prev)}
                >
                  {showConfirmPassword ? "Hide" : "Show"}
                </span>
              </div>
              {fieldErrors.confirmPassword && (
                <p className="field-error-upgradelogin">
                  {fieldErrors.confirmPassword}
                </p>
              )}

              <label>First name</label>
              <input
                type="text"
                name="firstName"
                placeholder="Your first name"
                value={formData.firstName}
                onChange={handleChange}
              />

              <label>Country of Residence *</label>
              <select
                name="country"
                value={formData.country}
                onChange={handleChange}
                className={fieldErrors.country ? "input-error" : ""}
              >
                <option value="">Select your country</option>
                {countries.map((c, idx) => (
                  <option key={idx} value={c.country}>
                    {c.country}
                  </option>
                ))}
              </select>
              {fieldErrors.country && (
                <p className="field-error-upgradelogin">
                  {fieldErrors.country}
                </p>
              )}

              {/* <button type="submit" className="paypal-btn" >
                Continue to PayPal →
              </button> */}
              {loading && <div style={{ color: "blue", marginTop:'5px' }}>Loading PayPal...</div>}
              <div
                ref={paypalRef}
                className="paypal-button-wrapper"
              ></div>


              <p className="note">
                You’ll be redirected to PayPal to securely complete your
                subscription.
              </p>

              <p className="footer-text">
                Already have an account?{" "}
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    setShowPopupSignup(true);
                  }}
                >
                  Log in instead
                </a>
              </p>
            </form>

            {/* PayPal button container (visible) */}

            {/* {loading && <div style={{ color: "blue" }}>Loading PayPal...</div>} */}
            {paymentSuccess && (
              <p style={{ color: "green", marginTop: "1rem" }}>
                ✅ Your Payment Successful!
              </p>
            )}
          </div>
        </div>
      )}

      {showPopupSignup && (
        <SignupPopup
          showPopup={showPopupSignup}
          handleClose={handleCloseSignup}
          setToken={setToken}
          hederLogin={true}
          withoutloginredirect={'pricing'}
          customError={customError}
          customId= {formData.email}
        />
      )}
    </>
  );
};

export default UpgradePopup;
